import axios from '@helper/Api/api';

const syncTransactionsApi = _ => axios.post(`/api/v1/odata/accounts/transactions/synchronizations`, {}, { headers: { authorization: 'Bearer ' + localStorage.getItem('token') } }).then(result => result.data)
const syncTransactionsApiGet = (query) => axios.get(`/api/v1/odata/accounts/transactions/synchronizations${query}`, { headers: { authorization: 'Bearer ' + localStorage.getItem('token') } }).then(result => result.data)

export {

  syncTransactionsApi,
  syncTransactionsApiGet
}